import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const ChannelSchema_ = createEnum(["REDO", "EBAY", "POSHMARK"], {
  enumName: "MarketplaceChannel",
});
export const ChannelSchema = ChannelSchema_;
export type Channel = z.infer<typeof ChannelSchema_>;

export const ChannelEnum = ChannelSchema_.enum;
